export default __webpack_public_path__ + "static/media/Group 10376.afefd49e.svg";